// src/store/userSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import secureLocalStorage from 'react-secure-storage';
import { getStoredData } from '@/utils/store';
import { RoleData } from '@/types';

interface SystemServiceState {
  roles: RoleData[] | []
}

const initialState: SystemServiceState = {
    roles: getStoredData<RoleData[]>('roles', []),
};

const systemServiceSlice = createSlice({
  name: 'systemService',
  initialState,
  reducers: {
    setSystemService: (state, action: PayloadAction<SystemServiceState>) => {
      state.roles = action.payload.roles
      secureLocalStorage.setItem('roles', JSON.stringify(action.payload.roles) || '');
    },
    setRoles: (state, action) => {
        state.roles = action.payload

        secureLocalStorage.setItem('roles', JSON.stringify(action.payload) || '');
    },
    clearSystemService: (state) => {
      state.roles = [];

      secureLocalStorage.removeItem('roles');
    },
  },
});

export const { setSystemService, setRoles, clearSystemService } = systemServiceSlice.actions;
export default systemServiceSlice.reducer;
